import React from 'react';
import { motion } from 'framer-motion';
import { Zap, Anchor, Coins, Clock } from 'lucide-react';
import styles from './SolanaPowered.module.css';

const features = [
  {
    icon: <Zap size={32} />,
    title: 'Low Fees, High TPS',
    description: 'Leverage Solana\'s high-speed network for instant gambling transactions'
  },
  {
    icon: <Anchor size={32} />,
    title: 'Anchor Compatible',
    description: 'Built on Solana\'s Anchor framework for robust smart contract development'
  },
  {
    icon: <Coins size={32} />,
    title: 'Native SPL Token Tools',
    description: 'Seamless integration with Solana\'s token ecosystem'
  },
  {
    icon: <Clock size={32} />,
    title: 'Solana Sysvar + Clock Slot RNG',
    description: 'Secure and verifiable random number generation'
  }
];

const SolanaPowered = () => {
  return (
    <section className={`${styles.solanaPowered} section`}>
      <div className="container">
        <motion.h2 
          className={`${styles.title} gradient-text`}
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
        >
          Built for Solana. Tuned for Speed.
        </motion.h2>
        
        <div className={styles.features}>
          {features.map((feature, index) => (
            <motion.div 
              key={index}
              className={styles.feature}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.2 }}
            >
              <div className={styles.icon}>
                {feature.icon}
              </div>
              <h3>{feature.title}</h3>
              <p>{feature.description}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default SolanaPowered; 